__turbopack_context__.v({
  "card": "style-module-scss-module__5Snnbq__card",
  "cardCta": "style-module-scss-module__5Snnbq__cardCta",
  "cardCtaArrow": "style-module-scss-module__5Snnbq__cardCtaArrow",
  "cardCtaLabel": "style-module-scss-module__5Snnbq__cardCtaLabel",
  "cardNumber": "style-module-scss-module__5Snnbq__cardNumber",
  "cardRow": "style-module-scss-module__5Snnbq__cardRow",
  "component": "style-module-scss-module__5Snnbq__component",
  "componentNoHeader": "style-module-scss-module__5Snnbq__componentNoHeader",
  "header": "style-module-scss-module__5Snnbq__header",
  "imageInner": "style-module-scss-module__5Snnbq__imageInner",
  "leftSection": "style-module-scss-module__5Snnbq__leftSection",
  "middleSection": "style-module-scss-module__5Snnbq__middleSection",
  "rightSection": "style-module-scss-module__5Snnbq__rightSection",
  "wrapper": "style-module-scss-module__5Snnbq__wrapper",
});
